import React from "react";
import playstoreImg from "../images/playstore.png";
import emailImg from "../images/email.png";
import phoneImg from "../images/phone.png";
import instaImg from "../images/insta.png";
import youtubeImg from "../images/youtube.png";
import addImg from "../images/add.png";
import logoImg from "../images/logo-long.jpg";
import webImg from "../images/web-icon.png";

function QrCards() {
  const downloadVCard = () => {
    const vCardData = `BEGIN:VCARD
VERSION:3.0
N:AlgoTurtle
FN:AlgoTurtle
ORG:AlgoTurtle
TITLE:Company
TEL;TYPE=CELL,VOICE:+91 8920044149
URL;TYPE=WORK:https://algoturtle.co.in/
URL;TYPE=INSTAGRAM:https://www.instagram.com/algoturtle
URL;TYPE=https://www.youtube.com/@algoTurtle
URL;TYPE=PLAYSTORE:https://play.google.com/store/apps/details?id=com.algoturtle
EMAIL;TYPE=INTERNET:santoshsinghalgoturtle@gmail.com
END:VCARD`;

    const blob = new Blob([vCardData], { type: "text/vcard" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "AlgoTurtle.vcf");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className="bg-gray-100 min-h-screen pt-10">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-6">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <img src={logoImg} alt="Logo" className="h-16" />
          <div className="flex items-center space-x-4">
            <h1 className="text-3xl font-bold text-gray-800">
              <span className="text-blue-700">algo</span>
              <span className="text-green-600">Turtle</span>
            </h1>
            <img
              src={addImg}
              alt="Add to Contact"
              className="h-10 cursor-pointer"
              onClick={downloadVCard}
            />
          </div>
        </div>

        {/* Contact Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Email */}
          <div className="flex items-center bg-gray-50 p-4 rounded-lg shadow">
            <a href="mailto:support@algoturtle.com" className="mr-4">
              <img src={emailImg} alt="Email Icon" className="h-12" />
            </a>
            <div>
              <p className="text-gray-700 font-medium">Send me an email</p>
              <a
                href="mailto:support@algoturtle.com"
                className="text-blue-600 hover:underline"
              >
                support@algoturtle.com
              </a>
            </div>
          </div>

          {/* Phone */}
          <div className="flex items-center bg-gray-50 p-4 rounded-lg shadow">
            <a href="tel:8920044149" className="mr-4">
              <img src={phoneImg} alt="Phone Icon" className="h-12" />
            </a>
            <div>
              <p className="text-gray-700 font-medium">Give me a call</p>
              <a
                href="tel:8920044149"
                className="text-blue-600 hover:underline"
              >
                +91 8920044149
              </a>
            </div>
          </div>

          {/* Play Store */}
          <div className="flex items-center bg-gray-50 p-4 rounded-lg shadow">
            <a
              href="https://play.google.com/store/apps/details?id=com.proalgoturtle"
              className="mr-4"
            >
              <img src={playstoreImg} alt="Play Store Icon" className="h-12" />
            </a>
            <div>
              <p className="text-gray-700 font-medium">
                Download from Play Store
              </p>
              <a
                href="https://play.google.com/store/apps/details?id=com.proalgoturtle"
                className="text-blue-600 hover:underline"
              >
                Google Play Store
              </a>
            </div>
          </div>

          {/* Website */}
          <div className="flex items-center bg-gray-50 p-4 rounded-lg shadow">
            <a href="https://algoturtle.co.in/" className="mr-4">
              <img src={webImg} alt="Website Icon" className="h-12" />
            </a>
            <div>
              <p className="text-gray-700 font-medium">Explore our website</p>
              <a
                href="https://algoturtle.co.in/"
                className="text-blue-600 hover:underline"
              >
                AlgoTurtle Website
              </a>
            </div>
          </div>

          {/* Instagram */}
          <div className="flex items-center bg-gray-50 p-4 rounded-lg shadow">
            <a href="https://www.instagram.com/AlgoTurtle/" className="mr-4">
              <img src={instaImg} alt="Instagram Icon" className="h-12" />
            </a>
            <div>
              <p className="text-gray-700 font-medium">
                Follow me on Instagram
              </p>
              <a
                href="https://www.instagram.com/AlgoTurtle/"
                className="text-blue-600 hover:underline"
              >
                Instagram: AlgoTurtle
              </a>
            </div>
          </div>

          {/* YouTube */}
          <div className="flex items-center bg-gray-50 p-4 rounded-lg shadow">
            <a href="https://www.youtube.com/@algoTurtle" className="mr-4">
              <img src={youtubeImg} alt="YouTube Icon" className="h-12" />
            </a>
            <div>
              <p className="text-gray-700 font-medium">Subscribe on YouTube</p>
              <a
                href="https://www.youtube.com/@algoTurtle"
                className="text-blue-600 hover:underline"
              >
                YouTube: AlgoTurtle
              </a>
            </div>
          </div>
        </div>

        {/* Save as Contact Button */}
        <div className="mt-6 text-center">
          <button
            className="bg-blue-600 text-white px-6 py-2 rounded-lg shadow hover:bg-blue-700"
            onClick={downloadVCard}
          >
            Save as Contact
          </button>
        </div>
      </div>
    </div>
  );
}

export default QrCards;
